// extracted by mini-css-extract-plugin
export default {"container":"Change_container__3vsnz","box":"Change_box__9gaK7","boxSelect":"Change_boxSelect__i5Wcg","boxBtn":"Change_boxBtn__GlVJ9"};